export function useBlackFriday() {
  function covertToGrDate(d: Date): Date {
    // get UTC time in msec
    const utc = d.getTime() + d.getTimezoneOffset() * 60000

    const offset = 2 // GMT +2 = greece

    return new Date(utc + 3600000 * offset)
  }

  const isWithinTbiBlackFridayPeriod = () => {
    const currentDate = covertToGrDate(new Date())
    const startEpoch = new Date(0)
    const endEpoch = new Date(0)
    const startUtc = startEpoch.setUTCSeconds(1732867200)
    const endUtc = endEpoch.setUTCSeconds(1733212800)
    const start = covertToGrDate(new Date(startUtc))
    const end = covertToGrDate(new Date(endUtc))

    return currentDate >= start && currentDate <= end
  }
  const isWithinCarBlackFridayPeriod = () => {
    const currentDate = covertToGrDate(new Date())
    const startEpoch = new Date(0)
    const endEpoch = new Date(0)
    const startUtc = startEpoch.setUTCSeconds(1732694400)
    const endUtc = endEpoch.setUTCSeconds(1733212800)
    const start = covertToGrDate(new Date(startUtc))
    const end = covertToGrDate(new Date(endUtc))
    return currentDate >= start && currentDate <= end
  }

  return {
    isWithinTbiBlackFridayPeriod,
    isWithinCarBlackFridayPeriod
  }
}
